(() => {
  const selectCreditcard = '.dc-creditcard'
  const selectOtherThanCreditcard = '.dc-other-than-creditcard'
  const selectRegisteredCreditcard = '.dc-registered-creditcard'
  const creditcardForm = '.dc_creditcard_form'
  const registeredCreditcardInfo = '.dc_registered_creditcard_info'

  const init = () => {
    if (location.href.indexOf('customer/day_camping/payment') < 1 ) {
      return
    }
    if (!$(selectCreditcard).prop('checked')) {
      $(creditcardForm).hide();
    }
    if (!$(selectRegisteredCreditcard).prop('checked')) {
      $(registeredCreditcardInfo).hide();
    }
    $('body')
      .on('change', '.dc-card-number-format-js', cardNumberFormat)
      .on('change', '.dc-security-code-format-js', cardNumberFormat)
      .on('click', selectCreditcard, showCreditcardForm)
      .on('click', selectOtherThanCreditcard, hideCreditcardForm)
      .on('click', selectRegisteredCreditcard, showRegisteredCreditcardInfo);
  }

  const showCreditcardForm = () => {
    $(creditcardForm).slideDown();
    $(registeredCreditcardInfo).slideUp();
  }

  const hideCreditcardForm = () => {
    $(creditcardForm).slideUp();
    $(registeredCreditcardInfo).slideUp();
  }

  const showRegisteredCreditcardInfo = () => {
    $(registeredCreditcardInfo).slideDown();
    $(creditcardForm).slideUp();
  }

  const cardNumberFormat = (e) => {
    e.preventDefault();
    $ele = $(e.currentTarget);
    $ele.val(z2hNum($ele.val()))
    $ele.val(removeHyphen($ele.val()))
  }

  const z2hNum = (str) => {
    return str.replace(/[０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    })
  }
  const removeHyphen = (str) => {
    return str.replace(/(\-|ー)/g, '');
  }
  $(init);
})();

